import { createApp } from 'vue';
import TicketsApp from './vue/TicketsApp.vue';
import { createI18n } from 'vue-i18n/dist/vue-i18n.cjs';
import { createPinia } from 'pinia';
import { VTooltip } from 'floating-vue';
import { installViplogeVueQuery } from './vue/plugins/queryClient';
import '@/shared/composables/useTheme';

function loadLocaleMessages() {
  return { nl: window.viploge.lng };
}

const i18n = createI18n({
  legacy: false, // Use Composition API mode (required for useI18n())
  warnHtmlInMessage: 'off',
  locale: 'nl',
  fallbackLocale: 'nl',
  messages: loadLocaleMessages(),
});

const currentPlatform = JSON.parse(
  document.getElementById('tickets-app').dataset.currentPlatform
);

const app = createApp(TicketsApp, {
  platform: currentPlatform,
});

app.config.globalProperties.$platform = currentPlatform;

app.directive('tooltip', VTooltip);

app.use(i18n);
app.use(createPinia());
installViplogeVueQuery(app);
app.mount('#tickets-app');
